export default __webpack_public_path__ + "static/media/calendar-poster.5f401581.svg";